import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Shield } from 'lucide-react';
import { Button } from './ui/button';

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const dismissed = localStorage.getItem('bs_cookie_consent');
    if (!dismissed) setVisible(true);
  }, []);

  const accept = () => {
    localStorage.setItem('bs_cookie_consent', 'accepted');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-50 bg-slate-900 border-t border-slate-700 px-4 py-3"
      data-testid="cookie-banner"
    >
      <div className="max-w-5xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-3">
        <div className="flex items-center gap-2 text-sm text-slate-300">
          <Shield className="w-4 h-4 text-slate-500 shrink-0" />
          <span>
            We use essential cookies for authentication and security.{' '}
            <Link to="/cookies" className="text-orange-400 hover:text-orange-300 underline underline-offset-2">
              Learn more
            </Link>
          </span>
        </div>
        <Button
          size="sm"
          onClick={accept}
          className="bg-slate-700 hover:bg-slate-600 text-white text-xs h-8 px-4 shrink-0"
          data-testid="cookie-accept-btn"
        >
          Understood
        </Button>
      </div>
    </div>
  );
}
